import React, {memo, useEffect, useState} from "react";
import {Col, Form, Row} from "react-bootstrap";

function AppWebReportZeit(props) {

    const [estimation,setEstimation]=useState({})
    const [meister,setMeister]=useState("")
    const [monteur,setMonteur]=useState("")
    const [geselle,setGeselle]=useState("")
    const [lehrling,setLehrling]=useState("")
    const [helfer,setHelfer]=useState("")
const [totalDuration,setTotalDuration]=useState("")

    useEffect(()=>{
        console.log(estimation)
        if(props.estimation===undefined){
            setEstimation({});
            setGeselle("")
            setMeister("")
            setLehrling("")
            setMonteur("")
            setHelfer("")
            setTotalDuration("")
        }
        else{
            setEstimation(props.estimation)
            setGeselle(props.estimation.roles.geselle)
            setMeister(props.estimation.roles.meister)
            setLehrling(props.estimation.roles.lehrling)
            setMonteur(props.estimation.roles.bauleitender_monteur)
            setHelfer(props.estimation.roles.helfer)
            setTotalDuration(props.estimation.totalduration)
        }
    },[props.estimation])




    return (<>
        <Row>
            <Col sm={4}>
                <label className="handwai-text-label-main">{"Zeit"}</label>
            </Col>
        </Row>
        <br/>

        <Row>
            <Col sm={1}>

            </Col>
            <Col sm={1} style={{marginLeft: -110, alignLeft: "left"}}>
                <label className="handwai-text-label-normal add-bottom-0-margin">
                    {"Nicht Schätzbar"}
                </label>
            </Col>
        </Row>

        <br/>
        <br/>

            <Row>
                <Col sm={1} style={{marginRight: -90}}>
                    <Form.Label
                        className="handwai-text-label-normal"
                    >
                        {'Meister:'}
                    </Form.Label>
                </Col>
                <Col sm={1}>
                    <input type="text" className="table-input"
                           style={{width: "100px", height: "30px"}}
                           disabled={true}
                           value={meister}
                    />
                </Col>

                <Col sm={2} style={{marginRight: -170}}>
                    <Form.Label
                        className="handwai-text-label-normal"
                    >
                        {'Bauleitender Monteur:'}
                    </Form.Label>
                </Col>
                <Col sm={1}>
                    <input type="text" className="table-input"
                           style={{width: "100px", height: "30px"}}
                           disabled={true}
                           value={monteur}
                    />
                </Col>

                <Col sm={1} style={{marginRight: -90}}>
                    <Form.Label
                        className="handwai-text-label-normal"
                    >
                        {'Geselle:'}
                    </Form.Label>
                </Col>
                <Col sm={1}>
                    <input type="text" className="table-input"
                           style={{width: "100px", height: "30px"}}
                           disabled={true}
                           value={geselle}
                    />
                </Col>

                <Col sm={1} style={{marginRight: -90}}>
                    <Form.Label
                        className="handwai-text-label-normal"
                    >
                        {'Lehrling:'}
                    </Form.Label>
                </Col>
                <Col sm={1}>
                    <input type="text" className="table-input"
                           style={{width: "100px", height: "30px"}}
                           disabled={true}
                           value={lehrling}

                    />
                </Col>

                <Col sm={1} style={{marginRight: -100}}>
                    <Form.Label
                        className="handwai-text-label-normal"
                    >
                        {'Helfer:'}
                    </Form.Label>
                </Col>
                <Col sm={1}>
                    <input type="text" className="table-input"
                           style={{width: "100px", height: "30px"}}
                           disabled={true}
                           value={helfer}

                    />
                </Col>

                <Col sm={1} style={{marginRight: -10}}>
                    <Form.Label
                        className="handwai-text-label-normal"
                    >
                        {'Gesamtstunden:'}
                    </Form.Label>
                </Col>
                <Col sm={1}>
                    <input type="text" className="table-input"
                           style={{width: "100px", height: "30px"}}
                           disabled={true}
                           defaultValue={totalDuration}
                    />
                </Col>

                <br/>
            </Row>



        <br/><br/><br/>
    </>)

}

export default memo(AppWebReportZeit)